import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface PaymentMethodsProps {
  className?: string
}

const PaymentMethods: React.FC<PaymentMethodsProps> = ({ className = '' }) => {
  const { t } = useTranslation()

  const payMethods = useMemo(
    () => ([
      { name: 'Apple Pay', icon: '/images/card/apple-pay.png' },
      { name: 'Google Pay', icon: '/images/card/google-pay.png' },
      { name: t('支付宝'), icon: '/images/card/ali-pay.png' },
      { name: t('微信支付'), icon: '/images/card/wechat-pay.png' },
    ]),
    [t]
  )

  return (
    <div className={`flex justify-center items-center space-x-4 px-10 py-2 rounded-full border-[0.5px] border-solid border-[#E5E5E5] ${className}`}>
      {payMethods.map(item => (
        <div
          key={item.name}
          className="flex items-center justify-center space-x-4"
        >
          <img className='max-h-5' src={item.icon} alt={item.name} />
        </div>
      ))}
    </div>
  )
}

export default PaymentMethods
